import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/contexts/ThemeProvider";

function sizeClasses(level, theme) {
  if (theme === "theme-brionj") {
    switch (level) {
      case 1:
        return "text-[44px] leading-[1.04] sm:text-[64px] md:text-[88px] tracking-[-0.02em] italic";
      case 2:
        return "text-[32px] leading-[1.05] sm:text-[42px] md:text-[56px] italic";
      case 3:
        return "text-[24px] leading-[1.15] md:text-[32px] italic";
      default:
        return "text-[20px] leading-[1.25] italic";
    }
  }
  if (theme === "theme-castlewood") {
    switch (level) {
      case 1:
        return "text-[40px] leading-[1.05] sm:text-[56px] md:text-[72px] tracking-[-0.015em] font-[900]";
      case 2:
        return "text-[28px] leading-[1.12] sm:text-[36px] md:text-[44px] font-[700]";
      case 3:
        return "text-[22px] leading-[1.2] md:text-[28px] font-[700]";
      default:
        return "text-[18px] leading-[1.3] font-[600]";
    }
  }
  if (theme === "theme-vela") {
    switch (level) {
      case 1:
        return "text-[38px] leading-[1.05] sm:text-[52px] md:text-[68px] font-[500]";
      case 2:
        return "text-[28px] leading-[1.12] sm:text-[36px] md:text-[50px] font-[500]";
      case 3:
        return "text-[22px] leading-[1.2] md:text-[26px] font-[500]";
      default:
        return "text-[18px] leading-[1.3] font-[500]";
    }
  }
  // gmh / admin
  switch (level) {
    case 1:
      return "text-[36px] leading-[1.08] sm:text-[48px] md:text-[60px] font-[500]";
    case 2:
      return "text-[26px] leading-[1.15] sm:text-[36px] md:text-[50px] font-[500]";
    case 3:
      return "text-[20px] leading-[1.25] md:text-[24px] font-[500]";
    default:
      return "text-[18px] leading-[1.3] font-[500]";
  }
}

export const BrandHeading = ({ as = "h2", level = 2, children, className, ...rest }) => {
  const { theme } = useTheme();
  const Comp = as;
  return (
    <Comp
      className={cn("font-display text-foreground", sizeClasses(level, theme), className)}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export default BrandHeading;
